import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { URL } from "../../store/actions/depannageActions"
import { terminerSignalement } from "../../store/actions/informationActions"
import { showToast } from "../../store/actions/toastActions"
import { COLORS } from "../../utilities/Constants"
import CustomModal from "../basics/interface/CustomModal"

// Les photos sont sérialisées avec une url relative (/media/...) → on préfixe
// par l'hôte de l'API.
const MEDIA = URL.replace(/\/$/, "")

const styles = {
	meta: {
		display: "flex",
		justifyContent: "space-between",
		fontSize: 12,
		color: COLORS.textLight,
		marginBottom: 8,
	},
	cat: { fontSize: 16, fontWeight: 600, marginBottom: 6 },
	texte: { fontSize: 14, color: COLORS.textMuted, whiteSpace: "pre-wrap" },
	photos: { display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 },
	photo: {
		width: 110,
		height: 110,
		objectFit: "cover",
		borderRadius: 8,
		border: `1px solid ${COLORS.border}`,
	},
	badgeTermine: { fontSize: 13, fontWeight: 600, color: COLORS.success },
}

// Détail d'un signalement (texte + médias) avec action « Terminer » —
// confirmation par switch sur le bouton (convention : pas de second modal
// au-dessus d'un modal). statut/fetchOpts sont transmis au refetch de la
// liste après terminaison (pagination de /signalements ; le planning utilise
// les défauts = tous les actifs).
const SignalementModal = ({
	info,
	onClose,
	statut = "actifs",
	fetchOpts = {},
}) => {
	const dispatch = useDispatch()
	const [confirm, setConfirm] = useState(false)
	const [saving, setSaving] = useState(false)

	const terminer = () => {
		if (!confirm) {
			setConfirm(true)
			return
		}
		setSaving(true)
		dispatch(terminerSignalement(info.id, statut, fetchOpts))
			.then(() => {
				dispatch(showToast("success", "Signalement terminé"))
				onClose()
			})
			.catch(() => {
				dispatch(showToast("danger", "Échec de l'opération."))
				setSaving(false)
				setConfirm(false)
			})
	}

	const buttons = [
		{
			title: "Fermer",
			styleName: "secondary",
			onClick: onClose,
			disabled: saving,
		},
	]
	if (!info.termine)
		buttons.push({
			title: saving ? "..." : confirm ? "Confirmer ?" : "Terminer",
			styleName: "primary",
			onClick: terminer,
			disabled: saving,
		})

	return (
		<CustomModal
			title="Signalement"
			onClose={() => (saving ? null : onClose())}
			buttons={buttons}
		>
			<div style={styles.meta}>
				<span>{info.initiale}</span>
				<span>{info.created_at}</span>
			</div>
			{info.categorie ? (
				<div style={styles.cat}>{info.categorie}</div>
			) : null}
			<div style={styles.texte}>{info.texte}</div>
			{info.photos && info.photos.length > 0 && (
				<div style={styles.photos}>
					{info.photos.map((p) => (
						<a
							key={`ph_${p.id}`}
							href={`${MEDIA}${p.url}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							<img
								src={`${MEDIA}${p.url}`}
								alt="photo signalement"
								style={styles.photo}
							/>
						</a>
					))}
				</div>
			)}
			{info.termine ? (
				<div style={{ marginTop: 12 }}>
					<span style={styles.badgeTermine}>✓ Terminé</span>
				</div>
			) : null}
		</CustomModal>
	)
}

export default SignalementModal
